import axios from 'axios';
import { getUsersQuery } from './queries';
import { buildExpressQuery, buildLoopbackQuery } from './queries/builders';
import { resolveId } from '../../utils';
import Split from '../split';

const getUserListDetails = ({ role, filterDeleted, fields } = {}) =>
    new Promise((resolve, reject) => {
        const queryBuilder = Split.getBooleanTreatment('use_express_auth_endpoints') ? buildExpressQuery : buildLoopbackQuery;
        const params = { filterSubUsers: true };
        if (fields) {
            params.fields = fields;
        }
        if (filterDeleted) {
            params.filterDeleted = filterDeleted;
        }
        if (role) {
            params.role = role;
        }
        const query = getUsersQuery({ ...params, queryBuilder });
        const request = axios.get(query);

        request
            .then((response) => {
                const users = Array.isArray(response.data) ? response.data.map(resolveId) : [];
                resolve({ users });
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to process request'));
            });
    });

export default getUserListDetails;
